import React, { Component } from 'react';
import './ButtonRight.module.scss';
import {history} from 'components/App/components/UnauthenticatedApp';

class DownloadButtonRight extends Component {

    render() {
        var { text } = this.props
        return (
            <a href= {`${this.props.link}`} styleName='button'>
                {text}
            </a>
        );  
    }
}

export default DownloadButtonRight;


// WEBPACK FOOTER //
// ./resources/assets/components/UI/download-button/DownloadButtonRight/DownloadButtonRight.jsx